import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { ModalService, AnalyticsService } from '@sm360/widget-commons-general';

import { FORGET_PASSWORD, LOGIN } from 'login/constants/modalNames.js';
import TAGS from 'login/constants/trackingTags';

import 'login/components/SignIn/Links/ForgetPasswordLink.scss';

class ForgetPasswordLink extends React.Component {
    constructor(props) {
        super(props);

        this.onPasswordForgotten = this.onPasswordForgotten.bind(this);
    }

    onPasswordForgotten(e) {
        e.preventDefault();
        ModalService.get(FORGET_PASSWORD).open();
        ModalService.get(LOGIN).close();
        AnalyticsService.gaTrigger(TAGS.LOGIN_WIDGET__FORGOT_PASSWORD());
    }

    render() {
        return (
            <div className="forgotPassword">
                <button
                    onClick={this.onPasswordForgotten}
                    className="sr-link"
                    data-test="login.sign-in.forget-password-redirection-button"
                >
                    {LocaleService.t('LOGIN.FORGOT_PASSWORD')}
                </button>
            </div>
        );
    }
}

ForgetPasswordLink.displayName = 'ForgetPasswordLink';

export default ForgetPasswordLink;



// WEBPACK FOOTER //
// ./src/components/SignIn/Links/ForgetPasswordLink.jsx